var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/WithDotsIcon/WithDotsIcon.tsx";
import React from 'react';
import { Dot, DotsWrap, WithDotsIconRoot } from "./WithDotsIcon.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var WithDotsIcon = function WithDotsIcon(_ref) {
  var children = _ref.children,
      blueDot = _ref.blueDot,
      greenDot = _ref.greenDot,
      withIcon = _ref.withIcon;
  return /*#__PURE__*/_jsxs(WithDotsIconRoot, {
    children: [children, blueDot || greenDot ? /*#__PURE__*/_jsxs(DotsWrap, {
      withIcon: withIcon,
      children: [blueDot && /*#__PURE__*/_jsx(Dot, {}), greenDot && /*#__PURE__*/_jsx(Dot, {
        isGreen: true
      })]
    }) : null]
  });
};